import moment from 'moment';
import mock from 'src/utils/mock';

mock.onGet('/api/reports/calls').reply(200, {
  calls: {
    datasets: [
      {
        data: [56, 24, 20],
        backgroundColor: ['#00C5DC', '#FFB822', '#716ACA']
      }
    ],
    labels: ['Inbound', 'Outbound', 'Broadcast']
  }
});

mock.onGet('/api/reports/vezeti-numbers').reply(() => {
  const numbers = [
    {
      id: '5eff2548979e396cb4b000ba',
      phone: '018881000',
      info: 'test',
      status: 'active',
      autoRenew: true
    },
    {
      id: '5eff254e46b753a166e7d7af',
      phone: '018881002',
      info: 'test2',
      status: 'inactive',
      autoRenew: false
    }
  ];
  return [200, { numbers }];
});

mock.onGet('/api/reports/user-calls').reply(() => {
  const calls = [
    {
      id: '5eff2548979e396cb4b000ba',
      destinationCalled: '08066428001',
      ext: 153,
      status: 'On Call',
      callerId: '018888003',
      durationInSeconds: 0,
      countryOperator: 'MTN Nigeria'
    },
    {
      id: '5eff2548979e396cb4b000fa',
      destinationCalled: '08066428001',
      ext: 153,
      status: 'On Call',
      callerId: '018888003',
      durationInSeconds: 0,
      countryOperator: 'MTN Nigeria'
    },
    {
      id: '5eff2548979e396cb4b000b3',
      destinationCalled: '08066428002',
      ext: 153,
      status: 'Wrap Up',
      callerId: '018888003',
      durationInSeconds: 18,
      countryOperator: 'MTN Nigeria'
    },
    {
      id: '5eff2548979e396cb4b000b2',
      destinationCalled: '08066428001',
      ext: 153,
      status: 'Idle',
      callerId: '018888003',
      durationInSeconds: 0,
      countryOperator: 'MTN Nigeria'
    }
  ];
  return [200, { calls }];
});

mock.onGet('/api/resources/time-group').reply(() => {
  const timeGroup = [
    {
      id: '5eff2548979e396cb4b000ba',
      name: 'Business Hours Time Group',
      info: 'test'
    },
    {
      id: '5eff254e46b753a166e7d7af',
      name: 'Close of Business',
      info: 'test2'
    }
  ];
  return [200, { timeGroup }];
});

mock.onGet('/api/resources/time-condtions').reply(() => {
  const timeCondition = [
    {
      id: '5eff2548979e396cb4b000ba',
      name: 'Business Call Routing',
      info: 'test'
    },
    {
      id: '5eff254e46b753a166e7d7af',
      name: 'Business Call Routing 2',
      info: 'test2'
    }
  ];
  return [200, { timeCondition }];
});

mock.onGet('/api/resources/logs').reply(() => {
  const logs = [
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(2, 'minutes')
        .subtract(56, 'seconds')
        .toDate()
        .getTime(),
      activity: 'Buy new Vezeti Number',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    },
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(2, 'minutes')
        .subtract(56, 'seconds')
        .toDate()
        .getTime(),
      activity: 'Add new SIP account',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    },
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(8, 'minutes')
        .subtract(23, 'seconds')
        .toDate()
        .getTime(),
      activity: 'Buy Credit',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    },
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(20, 'minutes')
        .subtract(54, 'seconds')
        .toDate()
        .getTime(),
      activity: 'Update Phone Number',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    },
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(20, 'minutes')
        .subtract(54, 'seconds')
        .toDate()
        .getTime(),
      activity: 'invalid login',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    },
    {
      user: 'James Ugbanu',
      role: 'Admin',
      createdAt: moment()
        .subtract(2, 'days')
        .subtract(20, 'minutes')
        .subtract(54, 'seconds')
        .toDate()
        .getTime(),
      activity: 'success login',
      ip: '102.89.1.34',
      location: 'Lagos, Nigeria'
    }
  ];

  return [200, { logs }];
});

let templates = [
  {
    id: '5ece2c077e39da27658aa8a9',
    image: null,
    name: 'Email Template 1',
    updatedAt: moment().subtract(6, 'hours').toDate().getTime(),
    userFirstName: 'James Ugbanu'
  },
  {
    id: '5ece2c077e39da27658aa8a8',
    image: null,
    name: 'Email Template 2',
    updatedAt: moment().subtract(2, 'hours').toDate().getTime(),
    userFirstName: 'Samuel'
  }
];

mock.onGet('/api/templates').reply(200, { templates });

const templateTest = {
  body: {
    rows: [
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'image',
                values: {
                  maxWidth: '100%',
                  src: {
                    url:
                      'https://a.mailmunch.co/user_data/landing_pages/1500310730675-logosample_03.png',
                    width: 266,
                    height: 62
                  },
                  draggable: true,
                  containerPadding: '10px 10px 20px',
                  deletable: true,
                  selectable: true,
                  action: {
                    url: '',
                    target: ''
                  },
                  altText: 'Image',
                  fullWidth: false,
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '10px 10px 5px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#000',
                  textAlign: 'center',
                  lineHeight: '120%',
                  text:
                    '<div><span style="color: #f10693; font-family: Pacifico, cursive; font-size: 14px; line-height: 16.8px;"><strong><span style="font-size: 80px; line-height: 96px;">Relax &amp; Plan</span></strong></span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '10px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#000',
                  textAlign: 'center',
                  lineHeight: '120%',
                  text:
                    '<div><span style="color: #6fbb7b; font-family: Pacifico, cursive; font-size: 58px; text-align: center; line-height: 69.6px;">&nbsp;Your Summer Break</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '20px 10px 9px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#000',
                  textAlign: 'center',
                  lineHeight: '140%',
                  text:
                    '<div><span style="font-size: 24px; color: #505050; line-height: 33.6px;">Time to plan a vacation for your kids?</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '5px 10px 10px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#000',
                  textAlign: 'center',
                  lineHeight: '160%',
                  text:
                    '<div><span style="font-size: 18px; line-height: 28.8px;"><span style="color: #505050; font-size: 18px; line-height: 28.8px;">Check-out our summer break offers for&nbsp;</span><span style="color: #505050; font-size: 18px; line-height: 28.8px;">children who are creative, full of energy,&nbsp;</span><span style="color: #505050; font-size: 18px; line-height: 28.8px;">and can&rsquo;t sit still for a minute.</span></span></div>'
                }
              },
              {
                type: 'divider',
                values: {
                  containerPadding: '20px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  width: '100%',
                  border: {
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: '#CCC'
                  },
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '20px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#000',
                  textAlign: 'left',
                  lineHeight: '120%',
                  text:
                    '<div><strong><span style="font-size: 30px; font-family: Montserrat, sans-serif; color: #2790d2; line-height: 36px;">Upcoming Events:</span></strong></div>'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '0px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1, 2],
        columns: [
          {
            contents: [
              {
                type: 'image',
                values: {
                  maxWidth: '100%',
                  src: {
                    url:
                      'https://a.mailmunch.co/user_data/landing_pages/1500313461528-1.png',
                    width: 500,
                    height: 500
                  },
                  draggable: true,
                  containerPadding: '0px',
                  deletable: true,
                  selectable: true,
                  action: {
                    url: '',
                    target: ''
                  },
                  altText: 'Image',
                  fullWidth: true,
                  textAlign: 'center'
                }
              }
            ]
          },
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px 8px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#6eba79',
                  textAlign: 'left',
                  lineHeight: '160%',
                  text:
                    '<div><span style="font-size: 20px; line-height: 32px;">JET SKI RIDE</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#4f4f4f',
                  textAlign: 'left',
                  lineHeight: '150%',
                  text:
                    '<div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation.</div>'
                }
              },
              {
                type: 'button',
                values: {
                  buttonColors: {
                    color: '#FFF',
                    backgroundColor: '#fa9302',
                    hoverColor: '#cf7a04'
                  },
                  calculatedHeight: 36,
                  calculatedWidth: 132,
                  href: '',
                  border: {},
                  text: 'ORDER NOW<br />',
                  draggable: true,
                  containerPadding: '5px 15px',
                  padding: '10px 20px',
                  deletable: true,
                  selectable: true,
                  textAlign: 'left',
                  lineHeight: '120%',
                  borderRadius: '20px'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'divider',
                values: {
                  containerPadding: '1px 20px 5px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  width: '100%',
                  border: {
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: '#CCC'
                  },
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '0px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [2, 1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px 8px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#6eba79',
                  textAlign: 'left',
                  lineHeight: '160%',
                  text:
                    '<div><span style="font-size: 20px; line-height: 32px;">BOAT RIDE</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#4f4f4f',
                  textAlign: 'left',
                  lineHeight: '150%',
                  text:
                    '<div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation</div>'
                }
              },
              {
                type: 'button',
                values: {
                  buttonColors: {
                    color: '#FFF',
                    backgroundColor: '#fa9302',
                    hoverColor: '#cf7a04'
                  },
                  calculatedHeight: 36,
                  calculatedWidth: 132,
                  href: '',
                  border: {},
                  text: 'ORDER NOW<br />',
                  draggable: true,
                  containerPadding: '5px 15px',
                  padding: '10px 20px',
                  deletable: true,
                  selectable: true,
                  textAlign: 'left',
                  lineHeight: '120%',
                  borderRadius: '20px'
                }
              }
            ]
          },
          {
            contents: [
              {
                type: 'image',
                values: {
                  maxWidth: '100%',
                  src: {
                    url:
                      'https://a.mailmunch.co/user_data/landing_pages/1500313783372-2.png',
                    width: 500,
                    height: 500
                  },
                  draggable: true,
                  containerPadding: '0px',
                  deletable: true,
                  selectable: true,
                  action: {
                    url: '',
                    target: ''
                  },
                  altText: 'Image',
                  fullWidth: true,
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'divider',
                values: {
                  containerPadding: '1px 20px 5px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  width: '100%',
                  border: {
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: '#CCC'
                  },
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '0px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1, 2],
        columns: [
          {
            contents: [
              {
                type: 'image',
                values: {
                  maxWidth: '100%',
                  src: {
                    url:
                      'https://a.mailmunch.co/user_data/landing_pages/1500314095876-3.png',
                    width: 500,
                    height: 500
                  },
                  draggable: true,
                  containerPadding: '0px',
                  deletable: true,
                  selectable: true,
                  action: {
                    url: '',
                    target: ''
                  },
                  altText: 'Image',
                  fullWidth: true,
                  textAlign: 'center'
                }
              }
            ]
          },
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px 8px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#6eba79',
                  textAlign: 'left',
                  lineHeight: '160%',
                  text:
                    '<div><span style="font-size: 20px; line-height: 32px;">BEACH DAY</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '10px 15px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#4f4f4f',
                  textAlign: 'left',
                  lineHeight: '150%',
                  text:
                    '<div>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation</div>'
                }
              },
              {
                type: 'button',
                values: {
                  buttonColors: {
                    color: '#FFF',
                    backgroundColor: '#fa9302',
                    hoverColor: '#cf7a04'
                  },
                  calculatedHeight: 36,
                  calculatedWidth: 132,
                  href: '',
                  border: {},
                  text: 'ORDER NOW<br />',
                  draggable: true,
                  containerPadding: '5px 15px',
                  padding: '10px 20px',
                  deletable: true,
                  selectable: true,
                  textAlign: 'left',
                  lineHeight: '120%',
                  borderRadius: '20px'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'divider',
                values: {
                  containerPadding: '1px 20px 5px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  width: '100%',
                  border: {
                    borderTopWidth: '1px',
                    borderTopStyle: 'solid',
                    borderTopColor: '#CCC'
                  },
                  textAlign: 'center'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '0px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '15px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#fa9302',
                  textAlign: 'center',
                  lineHeight: '130%',
                  text:
                    '<div><span style="font-size: 36px; line-height: 46.8px;">NEED MORE INFORMATION?</span></div>'
                }
              },
              {
                type: 'text',
                values: {
                  containerPadding: '10px',
                  selectable: true,
                  draggable: true,
                  deletable: true,
                  color: '#4f4f4f',
                  textAlign: 'center',
                  lineHeight: '120%',
                  text:
                    '<div><span style="font-size: 20px; line-height: 24px;">Subscribe to get updates.</span></div>'
                }
              },
              {
                type: 'button',
                values: {
                  buttonColors: {
                    color: '#FFF',
                    backgroundColor: '#6eba79',
                    hoverColor: '#58a864'
                  },
                  calculatedHeight: 52,
                  calculatedWidth: 214,
                  href: '',
                  border: {},
                  text:
                    '<span style="font-size: 20px; line-height: 32px;">SUBSCRIBE NOW</span>',
                  draggable: true,
                  containerPadding: '20px',
                  padding: '10px 20px',
                  deletable: true,
                  selectable: true,
                  textAlign: 'center',
                  lineHeight: '160%',
                  borderRadius: '37px'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: 'rgba(255,255,255,0)',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '10px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: true,
          draggable: true,
          deletable: true
        }
      },
      {
        cells: [1],
        columns: [
          {
            contents: [
              {
                type: 'text',
                values: {
                  containerPadding: '20px',
                  selectable: false,
                  draggable: false,
                  deletable: false,
                  color: '#000',
                  textAlign: 'left',
                  lineHeight: '120%',
                  text:
                    '<div style="font-family: arial, helvetica, sans-serif;"><span style="font-size: 12px; color: #999999; line-height: 14.4px;">You received this email because you signed up for [[business_name]].</span></div>\n<div style="font-family: arial, helvetica, sans-serif;">&nbsp;</div>\n<div style="font-family: arial, helvetica, sans-serif;"><span style="font-size: 12px; color: #999999; line-height: 14.4px;">[[{unsubscribe}]]</span></div>'
                }
              }
            ]
          }
        ],
        values: {
          backgroundColor: '#f0f0f0',
          backgroundImage: {
            url: '',
            fullWidth: true,
            repeat: false,
            center: false,
            cover: false
          },
          padding: '30px',
          columnsBackgroundColor: 'rgba(255,255,255,0)',
          selectable: false,
          draggable: false,
          deletable: false
        }
      }
    ],
    values: {
      backgroundColor: '#ffffff',
      backgroundImage: {
        url: '',
        fullWidth: true,
        repeat: false,
        center: true,
        cover: false
      },
      contentWidth: '600px',
      fontFamily: {
        label: 'Montserrat',
        value: "'Montserrat',sans-serif",
        type: 'google',
        weights: '400,700'
      }
    }
  }
};
mock.onGet('/api/edit-template/5ece2c077e39da27658aa8a8').reply(() => {
  const template = {
    id: '5ece2c077e39da27658aa8a8',
    image: null,
    name: 'Email Template 2',
    body: templateTest,
    updatedAt: moment().subtract(2, 'hours').toDate().getTime(),
    userFirstName: 'Samuel'
  };

  return [200, { template }];
});

mock.onGet('/api/users').reply(() => {
  const users = [
    {
      id: '5eff2548979e396cb4b000ba',
      firstName: 'Trouble',
      lastName: 'Violence',
      email: 'jane@vex.com',
      phoneNumber: +23498786452345,
      partner: 'James',
      status: 'active',
      date: '12-02-1999'
    },
    {
      id: '5eff2548979e396cb4b000bk',
      firstName: 'Max',
      lastName: 'Fury',
      email: 'fury@vex.com',
      phoneNumber: +23498786452345,
      partner: '',
      status: 'pending',
      date: '12-02-2021'
    },
    {
      id: '5eff2548979e396cb4b000bg',
      firstName: 'Tyson',
      lastName: 'Meek',
      email: 'jane@vex.com',
      phoneNumber: +23498786452345,
      partner: 'James',
      status: 'suspended',
      date: '12-02-2021'
    },
    {
      id: '5eff2548979e396cb4b000bf',
      firstName: 'Buddy',
      lastName: 'Bounce',
      email: 'buddy@vex.com',
      phoneNumber: +23498786452345,
      partner: 'James',
      status: 'active',
      date: '12-02-2021'
    }
  ];
  return [200, { users }];
});
